import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const state = {
    account_category_data: null,
    payment_category_data: null,
    content_category_data: null,
    activeLocale: 'en',
    showResults: false,
    activeCategory: null,
}

const getters = {
    accountCategoryData: (state) => {
        return state.account_category_data;
    },
    paymentCategoryData: (state) => {
        return state.payment_category_data;
    },
    contentCategoryData: (state) => {
        return state.content_category_data;
    },
    showResults: (state) => {
        return state.showResults;
    },
    activeCategory: (state) => {
        return state.activeCategory;
    },

}

const mutations = {
    POPULATE_ACCOUNT_CATEGORY_DATA: (state,payload) => {
        state.account_category_data = payload;
    },
    POPULATE_CONTENT_CATEGORY_DATA: (state,payload) => {
        state.content_category_data = payload;
    },
    POPULATE_PAYMENT_CATEGORY_DATA: (state,payload) => {
        state.payment_category_data = payload;
    },
    UPDATE_LOCALE: (state,payload) => {
        state.activeLocale = payload;
    },
    SHOW_RESULTS: (state, category) => {
        state.showResults = true;
        state.activeCategory = category;
    },
    HIDE_RESULTS: (state) => {
        state.showResults = false;
    },
}

const actions = {
    getQuestionData: ({ commit },payload) => {
        console.log(process.env.VUE_APP_BASE_API_URL + '/data/questions_' + payload + '.json')
        return axios.get(process.env.VUE_APP_BASE_API_URL + '/data/questions_'+ payload +'.json')
        .then(data => {
            commit('POPULATE_ACCOUNT_CATEGORY_DATA', data.data.account)
            commit('POPULATE_CONTENT_CATEGORY_DATA', data.data.content)
            commit('POPULATE_PAYMENT_CATEGORY_DATA', data.data.payment)
            return data.data;
        })
    },
    changeLocale: ({ commit },payload) => {
        commit('UPDATE_LOCALE', payload)
    },
    showResults: ({ commit, state }, category) => {
        if(category === null){
            category = state.activeCategory
        }
        commit('SHOW_RESULTS', category)
        return 200;
    },
    hideResults: ({ commit }) => {
        commit('HIDE_RESULTS')
        return 200;
    },
}

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
})